import IndividualTable from "../../../IndividualTable";
import { sampleData2 } from "../../sampleData";

const Distance30 = () => {
  let winners = [
    "327",
    "318",
    "219",
    "345",
    "330",
    "459",
    "322",
    "381"
  ];
  return <IndividualTable matchType={"16"} gender="F" event="30" subTitle="Zamby" data={sampleData2} topRankCount="8" winners={winners} />;
};
export default Distance30;
